module.exports = __webpack_public_path__ + "assets/img/blast_2.d71d97c4.png";